import React, { useState, useEffect } from 'react';
import PollOption from './InputElements/PollOption';
import { getCookie, setCookie } from '../../../Cureus/Cookies';

const Poll = ({handleAddWidget, widgetSidebarId, widget={}, handleUpdateWidget, slug}) => {
  const [title, setTitle] = useState(widget.title)
  const [blurb, setBlurb] = useState(widget.blurb)
  const [image, setImage] = useState(null)
  const [imageFilename, setImageFilename] = useState(widget.imageFilename)
  const [disabled, setDisabled] = useState(null)
  const [errorMessage, setErrorMessage] = useState("")
  const [configuration, setConfiguration] = useState(widget.configuration || {0: {correct: false, answer: ""}, 1: {correct: false, answer: ""}})

  useEffect(() => {
    let disable = true
    let keys = Object.keys(configuration)
    disable = !blurb || !hasCorrect()
    setDisabled(disable ? 'disabled' : 'false')
  }, [blurb, configuration])

  const handleAddWidgetWrapper = () => {
    deleteCookie()
    setDisabled('disabled')
    setErrorMessage('Please wait while we create your poll.')
    let params = createFormData()
    if(handleAddWidget) {
      handleAddWidget(params, true)
    } else {
      handleUpdateWidget(widget.widgetId, params, true)
    }
  }

  const deleteCookie = () => {
    let cookieValue = getCookie(`channel-poll-${slug}-${widget.widgetId}`)
    setCookie(`channel-poll-${slug}-${widget.widgetId}`, cookieValue, 0)
  }

  const hasCorrect = () => {
    return Object.keys(configuration).some((key) => {
      return configuration[key].correct
    })
  }

  const createFormData = () => {
    let formData = new FormData();
    if(widgetSidebarId) {
      formData.append("widget[parent_id]", widgetSidebarId)
    }
    formData.append("widget[type]", "Widget::Poll");
    formData.append("widget[resource_type]", "PictureQuiz");
    formData.append("widget[title]", title);
    formData.append("widget[blurb]", blurb);
    formData.append("widget[configuration]", JSON.stringify(configuration));
    if(image) {
      formData.append("widget[image]", image);
    }
    return formData;
  }

  const renderFilename = () => {
    if(imageFilename) {
      return <span>Uploaded: {imageFilename}</span>
    }
  }

  const renderOptions = () => {
    let keys = Object.keys(configuration)
    return keys.map((key, idx) => {
      let option = configuration[key]
      return (
        <PollOption
          key={idx}
          quizOption={option}
          idx={idx}
          onChangeAnswer={onChangeAnswer}
          onChangeCorrect={onChangeCorrect}
        />
      );
    })
  }

  const onChangeAnswer = (e, idx) => {
    let newConfig = {...configuration}
    newConfig[idx].answer = e.target.value
    setConfiguration(newConfig)
  }

  const onChangeCorrect = (e, index) => {
    let newConfig = {...configuration}
    let keys = Object.keys(configuration)
    keys.forEach((key, idx) => {
      if (index === idx && e.target.checked) {
        newConfig[key].correct = true
      } else {
        newConfig[key].correct = false
      }
    })
    setConfiguration(newConfig)
  };

  const addOptionField  = () => {
    let newConfig = {...configuration}
    newConfig[Object.keys(newConfig).length] = {correct: false, answer: ""}
    setConfiguration(newConfig)
  }

  const handleOptionFieldDisable = () => {
    return (Object.keys(configuration).length >= 10) ? 'disabled' : ''
  }

  return (
    <div className="reveal-modal small channel-design-modals" data-reveal>
      <div className="modal-body">
        <div className='modal-close'>
          <a href='#' className='cancel-modal'>
            <img src="https://public.cureus.com/close_x.png"/>
          </a>
        </div>
        <div className="modal-content middling">
          <div className="modal-header text-center">
            <h5>Quiz</h5>
            <hr/>
          </div>
          <div className="row">
            <div className="small-12 columns">
              <p>Create a multiple choice quiz to test visitors to your channel homepage! A question and at least two answer choices are required. Select the radio button next to the correct answer.</p>
            </div>
          </div>
          <div className="row">
            <div className="small-12 columns">
              <div className="input-container">
                <label>Quiz title</label>
                <input type="text" name="title" value={title} placeholder="Enter the title or theme of the quiz here." onChange={(e) => setTitle(e.target.value)}/>
                </div>
              </div>
          </div>
          <div className="row">
            <div className="small-12 columns">
              <div className="input-container">
                <label>Question</label>
                <input type="text" name="blurb" value={blurb} placeholder="Enter the question here." onChange={(e) => setBlurb(e.target.value)}/>
                </div>
              </div>
          </div>
          {renderOptions()}
          <div className="row">
            <div className="small-12 columns">
              <a className={'button secondary add-members ' + handleOptionFieldDisable()} onClick={addOptionField}>+ ADD ANSWER CHOICE</a>
            </div>
          </div>
          <div className="row file-container flex">
            <div className="small-8 columns file-uploads">
              <label htmlFor="image">Image (PNG, JPEG, TIFF files accepted)</label>
              <input
                id="image"
                type="file"
                onChange={(e) => setImage(e.target.files[0])}
              />
            </div>
            {renderFilename()}
          </div>
          <div className='modal-footer text-center'>
            <a className={"button primary " + disabled} onClick={handleAddWidgetWrapper}>Add</a>
            {disabled && <p className="error-message text-left">{errorMessage}</p>}
          </div>
        </div>
      </div>
    </div>
  )
}


export default Poll;